import React from 'react';
import Css from './Clouds.module.css';


export default function Clouds() {
  return  <>
  <span className={`${Css.clouds} ${Css.C1}`}></span>
  <span className={`${Css.clouds} ${Css.C2}`}></span>
  <span className={`${Css.clouds} ${Css.C3}`}></span>
  <span className={`${Css.clouds} ${Css.C4}`}></span>
  <span className={`${Css.clouds} ${Css.C5}`}></span>
</>;
}
